"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSOMigratePage = exports.SSOMigratePageConfig = void 0;
const centered_card_1 = require("../../components/centered.card/centered.card");
const theme_1 = require("../../components/theme");
const theme_2 = require("../../components/theme");
const migrate_user_1 = require("../../modules/auth/migrate.user");
const page_1 = require("../page");
const CSS = {
    container: 'c-MigratePage__container',
    card: 'c-MigratePage__Card',
    button: 'c-MigratePage__action',
    padding: 'c-MigratePage__spacing',
    centered: 'c-MigratePage_centered',
};
const Style = {
    [CSS.padding]: {
        paddingTop: theme_2.DefaultTheme.space(6),
    },
    [CSS.button]: {
        width: '100%',
    },
    [CSS.container]: {
        width: '100%',
        height: `calc(100vh - ${theme_2.DefaultTheme.space(6)})`,
        paddingTop: theme_2.DefaultTheme.space(6),
    },
    [CSS.centered]: {
        transform: 'translateX(50vw) translateY(50vh)',
        marginLeft: '-12px',
        marginTop: '-12px',
    },
};
(0, theme_1.addStyles)(Style);
exports.SSOMigratePageConfig = {
    type: 'internal',
    name: page_1.IkePageName.userSSOMigrate,
    path: '/auth/migrate',
    auth: { required: false },
    layout: { nav: false, banner: false },
};
class SSOMigratePage extends page_1.IkePage {
    constructor() {
        super(exports.SSOMigratePageConfig);
        this.name = 'SSOMigratePage';
        this.component = new migrate_user_1.UserSelfMigrate();
    }
    get nodes() {
        return centered_card_1.CenteredCard.view(this.component.view(), { className: CSS.card });
    }
}
exports.SSOMigratePage = SSOMigratePage;
//# sourceMappingURL=migrate.page.js.map